import { useLocale } from "./hooks/useLocale";
import { msg } from "./locales/translate.ts";
import { Box } from "@ui/box/Box";
import { Dialog } from "@ui/dialog/Dialog";
import { getDefaultLightTheme, GlobalTheme, ITheme } from "@ui/theme/GlobalTheme";
//import { useCreateRouter } from "badmfck-presenter";
import { s_invoke } from "badmfck-signal";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Config from "./Config";
import { GD } from "./GD";
import { INav, useCreateRouter } from "./services/Router";
import { sitemap } from "./Sitemap";
import { NotificationContainer } from "./tools/notify";
import { GlobalView } from "./view/GlobalView";
import { SessionTerminatedPopup } from "./view/popup/general/SessionTerminatedPopup";
import { S_SETTINGS_POPUP } from "./view/popup/SettingsPopup";
import { createGlobalStyle } from "styled-components";

const themeLight = getDefaultLightTheme();

themeLight.colors.backgroundPrimary = "hsl(40 18% 97%)";
themeLight.colors.panelBackgroundPrimary = "#ffffff";
themeLight.colors.divider = "hsl(30 10% 90%)";
themeLight.colors.textPrimary = "hsl(0 1% 37%)";
themeLight.colors.textSecondary = "hsl(0 1% 37%)";
themeLight.colors.chartForeground = "hsl(17 73% 37%)";
themeLight.colors.chartForegroundHover = "hsl(17 73% 32%)";

const AppGlobalStyle = createGlobalStyle`
	html,
	body,
	#root {
		min-height: 100%;
		background: hsl(40 18% 97%);
	}

	body {
		margin: 0;
		color: hsl(0 1% 37%);
	}

	* {
		box-sizing: border-box;
	}
`;

export const SETTINGS_ALLOWED_IDS = [1, 2, 22];

function App() {
	const localeRevision = useLocale();
	const [project] = GD.B_SELECTED_PROJECT.use();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);

	const [theme] = useState<ITheme>(themeLight);
	const { i18n } = useTranslation();

	// sitemap() returns a freshly filtered array each call; memoize so the reference is
	// stable across renders and useCreateRouter doesn't destroy + recreate the Router
	// (which re-processes the path and re-fires navigation) on every App render.
	const sitemapCurrent = useMemo<INav[]>(() => (project && user ? sitemap(project, user) : []), [localeRevision, project, user, i18n.resolvedLanguage]);

	const router = useCreateRouter(sitemapCurrent, <GlobalView />);

	useEffect(() => {
		s_invoke({ width: window.innerWidth, height: window.innerHeight }, "resize");
	}, []);

	return (
		<>
			<GlobalTheme theme={theme}>
				<AppGlobalStyle />
				{router}
				<Box
					onClick={() => {
						if (user && SETTINGS_ALLOWED_IDS.includes(user.id)) S_SETTINGS_POPUP.invoke(true);
					}}
					sx={{
						position: "fixed",
						bottom: "10px",
						right: "10px",
						fontSize: "9px",
						opacity: ".5",
						cursor: user && SETTINGS_ALLOWED_IDS.includes(user.id) ? "pointer" : "default",
					}}>
					{msg("v_353b9a33")}{Config.version}
				</Box>

				<Dialog />
				<SessionTerminatedPopup />
				<NotificationContainer />
			</GlobalTheme>
		</>
	);
}

//<AuthView/>

export default App;
